import {
  ValidatorFn,
  AbstractControl,
  ControlContainer,
  FormGroup,
  FormArray,
  FormControl
} from '@angular/forms';

// Custom validator for checkbox group
export function minCheckedOptions(min = 1): ValidatorFn {
  return (control: AbstractControl) => {
    if (control && control.value) {
      let options = 0;
      control.value.forEach(v => {
        if (v) {
          options++;
        }
      });
      return options < min && { minCheckedOptions: true };
    }
    return null;
  };
}

// Custom validator for range dates
export function dateRange(
  type: 'higher' | 'lower',
  compareWith: AbstractControl
): ValidatorFn {
  return (control: AbstractControl) => {
    if (control && control.value && compareWith && compareWith.value) {
      const { value } = control;
      const { value: compareValue } = compareWith;
      let valid: { dateRange: boolean };
      if(value==="Start Date (MM/DD/YYYY)" || value==="End Date (MM/DD/YYYY)")
        return null;

      if (type === 'higher') {
        const _date=Date.now();
        valid = value.getTime() < compareValue.getTime() && { dateRange: true };
      }
      if (type === 'lower') {
        valid = value.getTime() > compareValue.getTime() && { dateRange: true };
      }
      const sub = control.valueChanges.subscribe(val => {
        if (control.valid && compareWith.invalid) {
          compareWith.updateValueAndValidity();
        }
        sub.unsubscribe();
      });
      return valid;
    }
    return null;
  };
}

// Custom Validator for emails string
export function email(control: AbstractControl): { email: boolean } {
  if (control && control.value) {
    const pattern = new RegExp(
      /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9.-]+\.[a-z]{2,}$/gim
    );
    if (!control.value.match(pattern)) {
      return { email: true };
    }
    return null;
  }
}

// Custom Validator for multiple emails string
// export function multipleEmails(
//   control: AbstractControl
// ): { multipleEmails: boolean } {
//   if (control && control.value) {
//     const pattern = new RegExp(
//       /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9.-]+\.[a-z]{2,}$/gim
//     );
//     const emails = control.value.split(';');
//     for (const eMail of emails) {
//       if (!eMail.match(pattern)) {
//         return { multipleEmails: true };
//       }
//     }
//   }
//   return null;
// }

export function url(control: AbstractControl): { url: boolean } {
  if (control && control.value) {
    const pattern = new RegExp(
      /^(https|http):\/\/.*\.([a-z]{2,3})(\/.*)*$/,
      'i'
    );
    if (!pattern.test(control.value)) {
      return { url: true };
    }
  }
  return null;
}

export function findDeepControl(
  form: FormGroup | FormArray,
  controlName: string,
  value: any
): AbstractControl {
  if (form instanceof FormArray) {
    form.controls.forEach(ctrl => {
      return findDeepControl(ctrl as FormGroup, controlName, value);
    });
  } else {
    const control = form.get(controlName);
    if (control.value === value) {
      return control;
    } else {
      const keys = Object.keys(form.controls);
      keys.forEach(key => {
        if (form.get(key) instanceof FormArray) {
          return findDeepControl(
            form.get(key) as FormArray,
            controlName,
            value
          );
        } else if (form.get(key) instanceof FormGroup) {
          return findDeepControl(
            form.get(key) as FormGroup,
            controlName,
            value
          );
        }
      });
    }
  }
}
